'use strict';

var cov_1dn4f012xl = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/index.js',
      hash = '87a75273aeb79846bab6f6361d28c0a0c12463f4',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/index.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 44,
          column: 5
        }
      },
      '1': {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 32
        }
      },
      '2': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 68
        }
      },
      '3': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 49
        }
      },
      '4': {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 25,
          column: 7
        }
      },
      '5': {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 36
        }
      },
      '6': {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 32
        }
      },
      '7': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 51
        }
      },
      '8': {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 36
        }
      },
      '9': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 43,
          column: 7
        }
      },
      '10': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 42,
          column: 8
        }
      },
      '11': {
        start: {
          line: 35,
          column: 30
        },
        end: {
          line: 35,
          column: 58
        }
      },
      '12': {
        start: {
          line: 37,
          column: 10
        },
        end: {
          line: 39,
          column: 11
        }
      },
      '13': {
        start: {
          line: 38,
          column: 12
        },
        end: {
          line: 38,
          column: 64
        }
      },
      '14': {
        start: {
          line: 40,
          column: 10
        },
        end: {
          line: 40,
          column: 21
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 14,
            column: 7
          },
          end: {
            line: 14,
            column: 8
          }
        },
        loc: {
          start: {
            line: 14,
            column: 19
          },
          end: {
            line: 16,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 17,
            column: 10
          },
          end: {
            line: 17,
            column: 11
          }
        },
        loc: {
          start: {
            line: 17,
            column: 83
          },
          end: {
            line: 44,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 32,
            column: 36
          },
          end: {
            line: 32,
            column: 37
          }
        },
        loc: {
          start: {
            line: 32,
            column: 49
          },
          end: {
            line: 43,
            column: 5
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 34,
            column: 17
          },
          end: {
            line: 34,
            column: 18
          }
        },
        loc: {
          start: {
            line: 34,
            column: 24
          },
          end: {
            line: 41,
            column: 9
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 39,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 39,
            column: 11
          }
        }, {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 39,
            column: 11
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1dn4f012xl.s[0];
angular.module('app', ['ui.router', 'ngLodash', 'toastr',
// 'ngAnimate',
'angular-loading-bar', 'ui.tree', 'ngCookies', 'ui.bootstrap', 'angularMoment', 'chart.js']).run(function (amMoment) {
  ++cov_1dn4f012xl.f[0];
  ++cov_1dn4f012xl.s[1];

  amMoment.changeLocale('fr');
}).config(function (cfpLoadingBarProvider, toastrConfig, ChartJsProvider, $httpProvider) {
  ++cov_1dn4f012xl.f[1];
  ++cov_1dn4f012xl.s[2];

  // $httpProvider.defaults.withCredentials = true;

  cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
  ++cov_1dn4f012xl.s[3];
  cfpLoadingBarProvider.includeSpinner = false;
  // Charts.js
  ++cov_1dn4f012xl.s[4];
  ChartJsProvider.setOptions({
    colors: ['#00ADF9', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#803690']
  });

  ++cov_1dn4f012xl.s[5];
  toastrConfig.autoDismiss = true;
  ++cov_1dn4f012xl.s[6];
  toastrConfig.timeOut = 2000;
  ++cov_1dn4f012xl.s[7];
  toastrConfig.positionClass = 'toast-top-right';
  ++cov_1dn4f012xl.s[8];
  toastrConfig.progressBar = true;

  ++cov_1dn4f012xl.s[9];
  $httpProvider.interceptors.push(function ($injector) {
    ++cov_1dn4f012xl.f[2];
    ++cov_1dn4f012xl.s[10];

    return {
      request: function request(req) {
        ++cov_1dn4f012xl.f[3];

        var authService = (++cov_1dn4f012xl.s[11], $injector.get('AuthService'));
        // On place le token d'identification dans chaque requête, pour autant qu'il y en ait un.
        ++cov_1dn4f012xl.s[12];
        if (authService.sessionId()) {
          ++cov_1dn4f012xl.b[0][0];
          ++cov_1dn4f012xl.s[13];

          req.headers.Authorization = authService.sessionId();
        } else {
          ++cov_1dn4f012xl.b[0][1];
        }
        ++cov_1dn4f012xl.s[14];
        return req;
      }
    };
  });
});